import styled from 'styled-components';
import FormModal from 'components/FormModal';

export const StyledFormModal = styled(FormModal)`
    width: 600px;

    footer button {
        margin-right: unset;
    }
`;
